export const steps = {
  selectContacts: 1,
  pushContacts: 2,
  pushResults: 3
};